import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface ResourceType {
  id: number
  name: string
  status: number
  usage_count: number
}

interface Props {
  resource_types: ResourceType[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/resource_types" },
  { title: "Resource Types", href: "/admin/resource_types" },
]

export default function Index({ resource_types }: Props) {
  const handleDelete = (id: number, usageCount: number) => {
    const message =
      usageCount > 0
        ? "This type is in use. It will be deactivated instead of deleted. Continue?"
        : "Are you sure you want to delete this type?"

    if (confirm(message)) {
      router.delete(`/admin/resource_types/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Resource Types" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Resource Types</h1>
          <Link
            href="/admin/resource_types/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Type
          </Link>
        </div>

        {resource_types.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  ID
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  In Use
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {resource_types.map((rt) => (
                <tr key={rt.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {rt.id}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {rt.name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {rt.usage_count > 0 ? rt.usage_count : ""}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/resource_types/${rt.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(rt.id, rt.usage_count)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No resource types found.</p>
        )}
      </div>
    </AppLayout>
  )
}
